import { api } from "@/lib/axios";

export default function deleteOne(leadId: string) {
  return api.delete(`leads/${leadId}`);
}
